export default __webpack_public_path__ + "assets/header-logo.49c6d994.png";